import { render, staticRenderFns } from "./HUDUserForestTrees.vue?vue&type=template&id=2be2b3c5&scoped=true&"
import script from "./HUDUserForestTrees.vue?vue&type=script&lang=ts&"
export * from "./HUDUserForestTrees.vue?vue&type=script&lang=ts&"
import style0 from "./HUDUserForestTrees.vue?vue&type=style&index=0&id=2be2b3c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be2b3c5",
  null
  
)

export default component.exports